import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PSLoading from './PSLoading';

const StyledPSDynamicBasicTable = styled.div`
  background: #fff;
  width: 100%;
  table{
    border-collapse: collapse;
  }
  thead{
    border-bottom: 1px solid #F14B4B;
    
  }
  tbody td{
    border: 1px solid #101E41;

  }
  .tr-disabled {
    background: #80808012;
    .table-item {
      cursor: not-allowed;
      color: #7a7a7a !important;
      pointer-events: none;
    }
  }
  .container-table {
    border-spacing: 0px 10px;
    width: 100%;
    text-align: left;
    .table-header {
      color: #002655;
      font-size: 12px;
      padding-left: 10px;
      .table-header-field {
        padding: 0.5rem 10px;
      }
      .header-info-basic {
        padding-left: 10px;
      }
      .th-check {
        width: 15px;
      }
    }
    .table-item {
      color: #002655;
      padding: 0.7rem 10px;
     
    }
  }
`;

export const PSDynamicBasicTable = React.forwardRef(
  ({ headers, items, loading }, ref) => {
    return (
      <StyledPSDynamicBasicTable ref={ref}>
        {!loading ? (
          <table className="table-product-details">
            {items.length > 0 && (
              <thead>
                <tr>
                  {headers.map((header) => (
                    <th key={header.elementProp} className="table-header-field color-orange">
                      {header.headerColumn}
                    </th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {items.map((item, index) => {
                return (
                  <tr
                    key={`${item.id}-${index}`}
                  >
                    {headers.map((header) => (
                      <td className="table-item">
                        {item[header.elementProp]}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="loading-container">
            <PSLoading color="orange" />
          </div>
        )}
        {items.length === 0 && !loading && <p>No hemos encontrado formularios de contacto vigente!</p>}
      </StyledPSDynamicBasicTable>
    );
  }
);

PSDynamicBasicTable.displayName = 'PSDynamicBasicTable';

PSDynamicBasicTable.defaultProps = {
  headers: [],
  items: [],
  onSelect: () => {},
  loading: false,
};

PSDynamicBasicTable.propTypes = {
  headers: PropTypes.array,
  items: PropTypes.array,
  onSelect: PropTypes.func,
  loading: PropTypes.bool,
};

export default PSDynamicBasicTable;
